import { getLengthUnit, getWeightUnit } from '#helper';

const isKeyExist = (o, key) => Object.prototype.hasOwnProperty.call(o, key);

export const showCargoItemTitle = currentCargo =>
  isKeyExist(currentCargo, 'goods') && isKeyExist(currentCargo, 'container');

export const showCargo = currentCargo => isKeyExist(currentCargo, 'goods') ||
  isKeyExist(currentCargo, 'container') ||
  isKeyExist(currentCargo, 'goods') ||
  isKeyExist(currentCargo, 'description') ||
  isKeyExist(currentCargo, 'container') ||
  isKeyExist(currentCargo, 'length') ||
  isKeyExist(currentCargo, 'weight') ||
  (isKeyExist(currentCargo, 'fragile') && Boolean(currentCargo.fragile)) ||
  (isKeyExist(currentCargo, 'hazmat') && Boolean(currentCargo.hazmat));

export const getDimensionsInfo = (c, measurementSystem) => {
  const { length, width, height } = c;
  let description = `Package LxW: ${length}x${width}`;

  if (height) {
    description = `Package LxWxH: ${length}x${width}x${height}`;
  }

  return `${description}${getLengthUnit(measurementSystem)}`;
};

export const getWeightInfo = (weight, measurementSystem) => `${weight}${getWeightUnit(measurementSystem)}`;
